import { splitInstallments } from './salesCommissionForm';
import { resizedPayers } from './salesCommissionParticipantForm';

export const formWithResizedInstallments = (form, count) => {
  const resizedForm = splitInstallments(form, count);
  const currentInstallments = form.installments || [];
  const installments = resizedForm.installments.map((installment, index) => {
    const current = currentInstallments[index];
    if (!current) return installment;

    const payers = Array.isArray(current.payers) ? current.payers : [];
    return {
      ...installment,
      ...current,
      amount: installment.amount,
      payers: resizedPayers(
        { ...current, amount: installment.amount, payers },
        payers.length || 1
      ),
    };
  });
  return { ...resizedForm, installments };
};
